// extracted by mini-css-extract-plugin
export default {"contrain_header":"Contraindications_contrain_header__NMxcv","contrain_input":"Contraindications_contrain_input__dPY+t","contrain":"Contraindications_contrain__ZA6Pg"};